/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        slider: {
            handle: {
                width: {
                    value: "24px",
                    type: "dimension",
                },
                height: {
                    value: "24px",
                    type: "dimension",
                },
                borderWidth: {
                    value: "2px",
                    type: "dimension",
                },
                borderStyle: {
                    value: "solid",
                    type: "strokeStyle",
                },
                borderRadius: {
                    value: "9999px",
                    type: "dimension",
                },
                default: {
                    backgroundColor: {
                        value: "#ffffff",
                        type: "color",
                    },
                    borderColor: {
                        value: "#d3222a",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#f3f3f3",
                        type: "color",
                    },
                    borderColor: {
                        value: "#af292e",
                        type: "color",
                    },
                },
                active: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    borderColor: {
                        value: "#921a1d",
                        type: "color",
                    },
                },
                disabled: {
                    backgroundColor: {
                        value: "#ffffff",
                        type: "color",
                    },
                    borderColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
            },
            track: {
                height: {
                    value: "2px",
                    type: "dimension",
                },
                borderRadius: {
                    value: "1px",
                    type: "dimension",
                },
                inactive: {
                    backgroundColor: {
                        value: "#dadada",
                        type: "color",
                    },
                },
                active: {
                    backgroundColor: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                disabled: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
            },
        },
    },
};
export default tokens;
